import React, { FunctionComponent } from 'react';

export const NoPermission: FunctionComponent = () => (
  <>
    <p className="text-lg mb-sm">Error</p>
    <p>You do not have permission to perform that action</p>
  </>
);
